var React = require('react');

function ExternalLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.5 3.5V5.5H5.5V18.5H18.5V14.5H20.5C20.5 15.332 20.5 20.5 20.5 20.5H3.5L3.5 3.5H9.5ZM17.086 5.5H12.5V3.5H20.5V11.5H18.5V6.914L12.5 12.914L11.086 11.5L17.086 5.5Z","fill":"#E3E7ED"}));
}

ExternalLink.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ExternalLink;

ExternalLink.default = ExternalLink;
